module.exports = __webpack_public_path__ + "static/media/samar.566d07c6.jpg";